 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054":"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85":"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36":"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36","areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7":"areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7","areas":"areas","bank-account":"bank-account","bank-transaction":"bank-transaction","brands":"brands","cash-transaction":"cash-transaction","categories":"categories","cheque":"cheque","cheque-reminder":"cheque-reminder","cheques":"cheques","customer":"customer","customer-due":"customer-due","customer-payment":"customer-payment","customer-payments":"customer-payments","damages":"damages","departments":"departments","designations":"designations","dishonoured-cheque":"dishonoured-cheque","employees":"employees","expenses":"expenses","months":"months","paid-cheque":"paid-cheque","pending-cheque":"pending-cheque","product":"product","purchase-returns":"purchase-returns","purchases":"purchases","salary-payment":"salary-payment","sales":"sales","supplier":"supplier","supplier-payment":"supplier-payment","suppliers":"suppliers","units":"units","user":"user","bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce":"bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce","bank-ledger":"bank-ledger","bank-transactions":"bank-transactions","cash-transactions":"cash-transactions","customer-ledger":"customer-ledger","damage":"damage","employee":"employee","product-ledger":"product-ledger","purchase":"purchase","purchase-return":"purchase-return","salary-payments":"salary-payments","sale":"sale","sale-return":"sale-return","supplier-ledger":"supplier-ledger","damage-invoice~purchase-invoice~purinvoice~sale-invoice~saleinvoice":"damage-invoice~purchase-invoice~purinvoice~sale-invoice~saleinvoice","purinvoice":"purinvoice","saleinvoice":"saleinvoice","salary-generate":"salary-generate","salary-sheet":"salary-sheet","stock":"stock","supplier-due":"supplier-due","cash-ledger":"cash-ledger","customer-point":"customer-point","customers":"customers","profile-setting":"profile-setting","cash-view":"cash-view","damage-invoice":"damage-invoice","purchase-invoice":"purchase-invoice","sale-invoice":"sale-invoice","login":"login","purchase-return-invoice":"purchase-return-invoice","sale-return-invoice":"sale-return-invoice"}[chunkId]||chunkId) + "." + {"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054":"b01f53a9","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85":"d9c58e55","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36":"c64e41fd","areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7":"835642ed","areas":"2a20a533","bank-account":"b7f5a7f1","bank-transaction":"b925e07e","brands":"f1ccb76e","cash-transaction":"3e5c64e9","categories":"6d746b1a","cheque":"e8b90698","cheque-reminder":"2b0b99bb","cheques":"798702f9","customer":"26f2aa9f","customer-due":"32f4ae24","customer-payment":"fc312b91","customer-payments":"a79dd199","damages":"d4104c7d","departments":"cf69b970","designations":"ca42612c","dishonoured-cheque":"8981dfbd","employees":"dc6a336e","expenses":"ecfd96da","months":"92b10151","paid-cheque":"21ea23d5","pending-cheque":"3934a741","product":"35d12686","purchase-returns":"b9f33d03","purchases":"90e8dd35","salary-payment":"80d8b318","sales":"aeff64cf","supplier":"dc94071d","supplier-payment":"ec290d68","suppliers":"dc5feb06","units":"fca1a963","user":"a9f73308","bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce":"f7e60c4e","bank-ledger":"1978bff0","bank-transactions":"00fc4442","cash-transactions":"d6286eb5","customer-ledger":"a0adec39","damage":"286310a0","employee":"2c5662f4","product-ledger":"e3d59616","purchase":"f0022474","purchase-return":"4e9b52a2","salary-payments":"4f684c31","sale":"d9faa263","sale-return":"92a40714","supplier-ledger":"db28df8d","damage-invoice~purchase-invoice~purinvoice~sale-invoice~saleinvoice":"b8b87e17","purinvoice":"d44198e2","saleinvoice":"3430127c","salary-generate":"a7865638","salary-sheet":"3b856dee","stock":"464e28bd","supplier-due":"068622a8","cash-ledger":"cb3360cc","customer-point":"b39a1267","customers":"731e7906","profile-setting":"be09a64b","cash-view":"8dd4b7be","damage-invoice":"0ac8145a","purchase-invoice":"b5db7be0","sale-invoice":"e9a8c7f9","login":"20ae08cf","purchase-return-invoice":"77b6afce","sale-return-invoice":"a448d94f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054":1,"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85":1,"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36":1,"areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7":1,"areas":1,"bank-account":1,"bank-transaction":1,"brands":1,"cash-transaction":1,"categories":1,"cheque":1,"cheque-reminder":1,"cheques":1,"customer":1,"customer-due":1,"customer-payment":1,"customer-payments":1,"damages":1,"departments":1,"designations":1,"employees":1,"expenses":1,"months":1,"paid-cheque":1,"pending-cheque":1,"product":1,"purchase-returns":1,"purchases":1,"salary-payment":1,"sales":1,"supplier":1,"supplier-payment":1,"units":1,"user":1,"bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce":1,"bank-ledger":1,"bank-transactions":1,"cash-transactions":1,"customer-ledger":1,"damage":1,"employee":1,"product-ledger":1,"purchase":1,"purchase-return":1,"salary-payments":1,"sale":1,"sale-return":1,"supplier-ledger":1,"purinvoice":1,"saleinvoice":1,"salary-generate":1,"salary-sheet":1,"stock":1,"supplier-due":1,"cash-ledger":1,"customers":1,"cash-view":1,"damage-invoice":1,"purchase-invoice":1,"sale-invoice":1,"login":1,"purchase-return-invoice":1,"sale-return-invoice":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054":"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85":"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36":"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36","areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7":"areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7","areas":"areas","bank-account":"bank-account","bank-transaction":"bank-transaction","brands":"brands","cash-transaction":"cash-transaction","categories":"categories","cheque":"cheque","cheque-reminder":"cheque-reminder","cheques":"cheques","customer":"customer","customer-due":"customer-due","customer-payment":"customer-payment","customer-payments":"customer-payments","damages":"damages","departments":"departments","designations":"designations","dishonoured-cheque":"dishonoured-cheque","employees":"employees","expenses":"expenses","months":"months","paid-cheque":"paid-cheque","pending-cheque":"pending-cheque","product":"product","purchase-returns":"purchase-returns","purchases":"purchases","salary-payment":"salary-payment","sales":"sales","supplier":"supplier","supplier-payment":"supplier-payment","suppliers":"suppliers","units":"units","user":"user","bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce":"bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce","bank-ledger":"bank-ledger","bank-transactions":"bank-transactions","cash-transactions":"cash-transactions","customer-ledger":"customer-ledger","damage":"damage","employee":"employee","product-ledger":"product-ledger","purchase":"purchase","purchase-return":"purchase-return","salary-payments":"salary-payments","sale":"sale","sale-return":"sale-return","supplier-ledger":"supplier-ledger","damage-invoice~purchase-invoice~purinvoice~sale-invoice~saleinvoice":"damage-invoice~purchase-invoice~purinvoice~sale-invoice~saleinvoice","purinvoice":"purinvoice","saleinvoice":"saleinvoice","salary-generate":"salary-generate","salary-sheet":"salary-sheet","stock":"stock","supplier-due":"supplier-due","cash-ledger":"cash-ledger","customer-point":"customer-point","customers":"customers","profile-setting":"profile-setting","cash-view":"cash-view","damage-invoice":"damage-invoice","purchase-invoice":"purchase-invoice","sale-invoice":"sale-invoice","login":"login","purchase-return-invoice":"purchase-return-invoice","sale-return-invoice":"sale-return-invoice"}[chunkId]||chunkId) + "." + {"areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~d4d4d054":"e5a04aaf","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-ledger~cash-transactio~a5a7bc85":"460ac60a","areas~bank-account~bank-ledger~bank-transaction~bank-transactions~brands~cash-transaction~cash-trans~f5d93a36":"c48a28e3","areas~bank-account~bank-transaction~brands~cash-transaction~categories~cheque~cheque-reminder~cheque~13a739e7":"5ffd811a","areas":"41b43c93","bank-account":"9c118a13","bank-transaction":"3d0827a6","brands":"41b43c93","cash-transaction":"c3567dd0","categories":"cd69506c","cheque":"30315f6d","cheque-reminder":"9a5e579b","cheques":"b6724194","customer":"dbbfe65b","customer-due":"bc51ab06","customer-payment":"26fff870","customer-payments":"2297bf5c","damages":"81f1505d","departments":"41b43c93","designations":"41b43c93","dishonoured-cheque":"31d6cfe0","employees":"2c20821c","expenses":"cd69506c","months":"41b43c93","paid-cheque":"a12a982a","pending-cheque":"41b43c93","product":"4975a307","purchase-returns":"1a4dd3e4","purchases":"76c6d779","salary-payment":"2ccc8d2a","sales":"54e622c8","supplier":"ecb6883b","supplier-payment":"8540c665","suppliers":"31d6cfe0","units":"41b43c93","user":"4c9fb101","bank-ledger~bank-transactions~cash-ledger~cash-transactions~customer-ledger~damage~employee~product-~257b36ce":"2090ba31","bank-ledger":"f9fea2bb","bank-transactions":"1d46eb99","cash-transactions":"768e105a","customer-ledger":"bdeabc52","damage":"a14dac8c","employee":"28368671","product-ledger":"a56a0702","purchase":"f804d3c1","purchase-return":"71edbb94","salary-payments":"3ac184b1","sale":"4f5b48e4","sale-return":"dcc13d4e","supplier-ledger":"fe0cc503","damage-invoice~purchase-invoice~purinvoice~sale-invoice~saleinvoice":"31d6cfe0","purinvoice":"b191206a","saleinvoice":"8e2138ec","salary-generate":"f60a0d8c","salary-sheet":"1bd17a80","stock":"57f9d37a","supplier-due":"546cc544","cash-ledger":"1d730127","customer-point":"31d6cfe0","customers":"58647f50","profile-setting":"31d6cfe0","cash-view":"8d67b5dc","damage-invoice":"b97d0e36","purchase-invoice":"3db04b3f","sale-invoice":"3aa754e5","login":"8cdc2d0a","purchase-return-invoice":"cefb2d17","sale-return-invoice":"752fb905"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
